<template>
    <footer>
        <div class="container">
            <img src="../assets/images/footer/logo.png" class="logo" alt="">

            <div class="nav-box">
                <router-link to="/terms_of_service" target="_blank">TERMS OF SERVICE</router-link>
                <router-link to="/privacy_policy" target="_blank">PRIVACY POLICY</router-link>
            </div>
            <!-- <p class="copyinfo">©2017 Hypergryph Co., Ltd  ©2019 YOSTAR LIMITED</p> -->
        </div>
    </footer>
</template>

<script>
export default {
    name: "footerBar",

    components: {

    },
    data: () => ({
    }),
    created() {

    },
    mounted() {

    },
    watch: {

    },
    computed: {

    },
    methods: {

    },
};
</script>

<style lang="scss" scoped>
footer {
    border-top: 1px solid #535353;
    padding: pxTorem(48px) 0 pxTorem(44px);

    .container {
        width: pxTorem(660px);
        margin: 0 auto;

        .logo {
            width: 100%;
        }
        .nav-box {
            margin-top: pxTorem(34px);
            display: flex;
            justify-content: center;
            font-family: "微软雅黑";

            a {
                font-size: pxTorem(16px);
                color: #fff;

                &:nth-of-type(1) {
                    margin-right: pxTorem(34px);
                }
            }
        }
        .copyinfo {
            margin-top: pxTorem(34px);
            font-family: "微软雅黑";
            font-size: pxTorem(16px);
            color: #fff;
            text-align: center;
        }
    }
}
</style>
